// SSR intro copy so listing / hub pages carry real, extractable text
// (not just a product grid) for search engines and LLM crawlers. Pure
// presentational — pass `title` and either a string or rich `children`.
// `width` matches the host page's content container (defaults to the
// singles picker / catalog width) so the block doesn't render as a narrow
// column under wider content.
const SeoIntro = ({ title, children, className = "", width = "max-w-6xl" }) => {
  if (!title && !children) return null;

  return (
    <section className={`w-full ${width} mx-auto px-4 mt-8 mb-4 ${className}`}>
      {title ? (
        <h2 className="text-xl font-bold text-gray-900 mb-2">{title}</h2>
      ) : null}
      {typeof children === "string" ? (
        <p className="text-gray-600 leading-relaxed">{children}</p>
      ) : (
        children
      )}
    </section>
  );
};

export default SeoIntro;
